import { Link } from 'react-router-dom';
import React from 'react';

const MainMenu = () => {
    const menuLinkStyle = { fontSize: '16px' };

    return (
        <>
            <ul>
                <li className='menu-item'><Link to='/' style={menuLinkStyle}>Anasayfa</Link>
                </li>  
                <li className='menu-item'><Link to='/hakkimizda' style={menuLinkStyle}>Hakkımızda</Link>
                </li>
                <li className='menu-item'><Link to='/projeler' style={menuLinkStyle}>Projeler</Link>
                </li>
                <li className='menu-item'><Link to='/iletisim' style={{ ...menuLinkStyle, textTransform: 'none' }}>İLETİŞİM</Link>
                </li>
            </ul>  
        </>
    );
};

export default MainMenu;